<template>
  <vue-extend-layouts />
</template>

<script>
/*import 'bootstrap/dist/css/bootstrap.css'*/
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueExtendLayouts from 'vue-extend-layout'

export default {
  name: 'App',
  components: { VueExtendLayouts },
  sockets: {
    connect() {
      console.log("connected");
    },
    newdeposit() {
      var audio = new Audio('/audio/newdeposit.mp3') // path to file
      setTimeout(function() {
        audio.play()
      }, 0);
    },
    wdrequest() {
      var audio = new Audio('/audio/wdrequest.mp3') // path to file
      setTimeout(function() {
        audio.play()
      }, 0);
    }
  }
}
</script>